import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  key: 1,
  type: "button",
  class: "btn btn-primary btn-lg",
  disabled: ""
}
const _hoisted_6 = {
  key: 1,
  class: "container"
}
const _hoisted_7 = {
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]

import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute } from 'vue-router'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import ValidationError from '@common/Components/ValidationError.vue'
    import { useCurrentUserQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import { useCreateServiceUserCommandV1 } from '@Organizations/Users/commands-vue-composables'

    // ---------------- route ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateServiceAccountPage',
  setup(__props) {

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid))

    // ---------------- local state ----------------

    const email = ref('')
    const displayName = ref('')
    //const description = ref('')

    // ---------------- queries ----------------

    const { runCurrentUserQueryV1 } =
        useCurrentUserQueryV1(false, false, true)

    // ---------------- command ----------------

    const {
        invokeCreateServiceUserCommandV1,
        invokingCreateServiceUserCommandV1,
        validationErrors,
        succeedCreateServiceUserCommandV1,
        errorCreateServiceUserCommandV1
    } = useCreateServiceUserCommandV1(
        '0',
        tid,
        email,
        displayName
    )

    // ---------------- derived ----------------

    const serviceAccountCreated = computed(
        () => succeedCreateServiceUserCommandV1.value === true
    )

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = 'Create Service Account'
        runCurrentUserQueryV1()
    })

    // ---------------- handlers ----------------

    function handleCreateServiceUserCommandV1()
    {
        invokeCreateServiceUserCommandV1()
    }

    function handleFinish()
    {
        email.value = ''
        displayName.value = ''
        //description.value = ''
    }

    // ---------------- error handling ----------------

    watch(errorCreateServiceUserCommandV1, (err) =>
    {
        if (err)
        {
            alert(err)
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Create a Service Account</h1><p class=\"text-muted\">Service accounts are used for API access and automation. They use API keys or tokens for authentication, not passwords.</p></div><div class=\"col-lg-5 col-sm-6 text-right\"></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    (!serviceAccountCreated.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("label", { for: "Email" }, "Email:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              type: "email",
              class: "form-control",
              placeholder: "Email address for service account"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, email.value]
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("small", { class: "form-text text-muted" }, "This email will be used to identify the service account.", -1 /* CACHED */)),
            _createVNode(ValidationError, {
              context: "Email",
              errors: _unref(validationErrors)
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { for: "DisplayName" }, "Display name:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((displayName).value = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Display name for service account"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, displayName.value]
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("small", { class: "form-text text-muted" }, "A descriptive name for this service account (e.g., \"CI/CD Pipeline\", \"Data Sync Service\").", -1 /* CACHED */)),
            _createVNode(ValidationError, {
              context: "DisplayName",
              errors: _unref(validationErrors)
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createCommentVNode("<div class=\"form-group\">\n                <label for=\"Description\">Description (optional):</label>\n                <textarea v-model=\"description\" class=\"form-control\" rows=\"3\" placeholder=\"Purpose of this service account\"></textarea>\n                <small class=\"form-text text-muted\">Describe what this service account will be used for.</small>\n            </div>"),
          _cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "alert alert-info",
            role: "alert"
          }, [
            _createElementVNode("strong", null, "Note:"),
            _createTextVNode(" Service accounts cannot sign in through the web UI and do not use passwords. They authenticate using API keys or access tokens which can be generated after creation. ")
          ], -1 /* CACHED */)),
          (!_unref(invokingCreateServiceUserCommandV1))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: handleCreateServiceUserCommandV1,
                type: "button",
                class: "btn btn-primary btn-lg"
              }, "Create Service Account"))
            : (_openBlock(), _createElementBlock("button", _hoisted_5, "Creating..."))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "alert-heading" }, "Service Account Created!", -1 /* CACHED */)),
            _createElementVNode("p", null, [
              _cache[7] || (_cache[7] = _createTextVNode("Service account ", -1 /* CACHED */)),
              _createElementVNode("strong", null, _toDisplayString(email.value), 1 /* TEXT */),
              _cache[8] || (_cache[8] = _createTextVNode(" was created successfully.", -1 /* CACHED */))
            ])
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "fg-color-blue" }, "Next steps:", -1 /* CACHED */)),
          _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/organizations/users/manage/type/${email.value}`,
            class: "btn btn-success text-white",
            style: {"padding":"0.7em 2em"}
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("i", {
              class: "fa fa-key",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createElementVNode("span", null, "Generate API keys", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_8),
          _cache[15] || (_cache[15] = _createElementVNode("h4", {
            class: "fg-color-blue",
            style: {"margin":"20px 0"}
          }, "or", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/organizations/users/service-accounts/${tid.value}`,
            class: "btn btn-secondary text-white",
            style: {"padding":"0.7em 2em"}
          }, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("i", {
              class: "fa fa-list",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createElementVNode("span", null, "View all service accounts", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_9),
          _cache[16] || (_cache[16] = _createElementVNode("h4", {
            class: "fg-color-blue",
            style: {"margin":"20px 0"}
          }, "or", -1 /* CACHED */)),
          _createElementVNode("button", {
            onClick: handleFinish,
            class: "btn btn-secondary text-white",
            style: {"padding":"0.7em 2em"}
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("i", {
              class: "fa fa-plus",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createElementVNode("span", null, "Create another service account", -1 /* CACHED */)
          ]))])
        ]))
  ]))
}
}

})